import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { AuthProvider } from 'react-oidc-context';

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_5kOhvTXr2",
  client_id: "3ilfckt6dqutskq23jgg1gjafr",
  redirect_uri: window.location.hostname === 'localhost' ? "http://localhost:3000" : "https://app.georgii.tech",
  response_type: "code",
  scope: "aws.cognito.signin.user.admin email openid profile",
  loadUserInfo: false,
  client_secret: (import.meta as any).env?.VITE_COGNITO_CLIENT_SECRET,
  onSignoutCallback: () => {
    window.history.replaceState({}, '', "/")
  },
  onSigninCallback: () => {
    // Clear any error parameters from the URL
    const url = new URL(window.location.href);
    url.searchParams.delete('error');
    url.searchParams.delete('error_description');
    url.searchParams.delete('state');
    url.searchParams.delete('code');
    window.history.replaceState({}, document.title, url.pathname);
  },
  metadataSeed: {
    authorization_endpoint: "https://login.georgii.tech/oauth2/authorize",
    token_endpoint: "https://login.georgii.tech/oauth2/token",
    end_session_endpoint: "https://login.georgii.tech/logout",
  },
  // Add automatic silent renewal to prevent token expiration
  automaticSilentRenew: true,
  // Add error handling for common auth issues
  extraQueryParams: {},
  // Handle token refresh
  accessTokenExpiringNotificationTime: 60,
  // Force a fresh login on certain errors
  extraTokenParams: {},
  // Add additional error handling
  onUserUnloaded: () => {
    console.log('User unloaded - clearing any cached data');
  },
  // Handle silent renew errors
  onSilentRenewError: (error: any) => {
    console.error('Silent renew error:', error);
    // Clear any cached data on silent renew failure
    localStorage.removeItem('oidc.user');
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)